import type { ExperienceReturnStatus } from '@ecomm/shared-ninetailed/useNinetailedFeatureFlag'
import type { ReactNode, RefObject } from 'react'
import { Suspense } from 'react'
import { renderClonedChildrenWithAIProps } from './renderClonedChildrenWithAIProps'

type Props = {
  readonly children: ReactNode
  readonly experimentRef: RefObject<HTMLDivElement>
  readonly isVariant: boolean
  readonly status: ExperienceReturnStatus
  readonly enabled?: boolean
}

/**
 * Wraps children with experiment div and suspense for AI Chat experiment.
 * @returns JSX.Element
 */
export function AIChatExperimentWrapper({
  children,
  enabled,
  experimentRef,
  isVariant,
  status
}: Props) {
  if (enabled) {
    const component = status === 'loading' || !isVariant ? null : children

    return (
      <div
        id="experimentWrapper"
        data-testid="experimentWrapper"
        ref={experimentRef}
      >
        <Suspense>{renderClonedChildrenWithAIProps(component)}</Suspense>
      </div>
    )
  }
  return null
}
